export const propertyListEn = {
  propertyList: {
    actions: {
      addProperty: 'Add Property',
    },
    filters: {
      search: 'Search',
      propertyType: 'Property Type',
      cities: 'Cities',
      status: 'Status',
      allFilters: 'All Filters',
      removeFilters: 'Remove ({count}) Filters',
    },
    cardFormOptions: {
      buildingType: 'Property Type',
      cityId: 'Cities',
      status: 'Status',
      bsLinked: 'Linked to Building Stack',
      ownershipGroup: 'Ownership Group',
    },
    columns: {
      properties: 'Properties',
      type: 'Type',
      city: 'City',
      propertyScore: 'Property Score',
      avgUnitScore: 'Average Unit Score',
      listingScore: 'Listing Score',
      units: 'Units',
      media: 'Media',
      status: 'Status',
      websiteFeatured: 'Website Featured',
    },
    tooltips: {
      bstkIntegration: 'With your Building Stack Integration, properties must now be created in the Building Stack platform',
      listingScoreHelper: 'Listing Score is a performance indicator that measures the content, quality and completeness of your rental listings.',
      websiteFeaturedHelper: 'Feature your property on website',
      websiteFeaturedBstkManaged: 'This field is managed by your Building Stack integration. Changes made will be temporary.',
    },
    values: {
      yes: 'Yes',
      no: 'No',
    },
    options: {
      buildingType: {
        residential: 'Residential',
        commercial: 'Commercial',
        recreational: 'Recreational',
        other: 'Other',
      },
    },
  },
} as const;

export const propertyListFr = {
  propertyList: {
    actions: {
      addProperty: 'Ajouter une propriété',
    },
    filters: {
      search: 'Rechercher',
      propertyType: 'Type de propriété',
      cities: 'Villes',
      status: 'Statut',
      allFilters: 'Tous les filtres',
      removeFilters: 'Retirer ({count}) filtres',
    },
    cardFormOptions: {
      buildingType: 'Type de propriété',
      cityId: 'Villes',
      status: 'Statut',
      bsLinked: 'Lié à Building Stack',
      ownershipGroup: 'Groupe de propriété',
    },
    columns: {
      properties: 'Propriétés',
      type: 'Type',
      city: 'Ville',
      propertyScore: 'Score de propriété',
      avgUnitScore: 'Score moyen des unités',
      listingScore: 'Score d\'annonce',
      units: 'Unités',
      media: 'Médias',
      status: 'Statut',
      websiteFeatured: 'Vedette du site web',
    },
    tooltips: {
      bstkIntegration: 'Avec votre intégration Building Stack, les propriétés doivent maintenant être créées dans la plateforme Building Stack',
      listingScoreHelper: 'Le score d\'annonce est un indicateur de performance mesurant le contenu, la qualité et la complétude de vos annonces locatives.',
      websiteFeaturedHelper: 'Mettre cette propriété en vedette sur le site web',
      websiteFeaturedBstkManaged: 'Ce champ est géré par votre intégration Building Stack. Les modifications apportées seront temporaires.',
    },
    values: {
      yes: 'Oui',
      no: 'Non',
    },
    options: {
      buildingType: {
        residential: 'Résidentiel',
        commercial: 'Commercial',
        recreational: 'Récréatif',
        other: 'Autre',
      },
    },
  },
} as const;
